import { createReducer, on } from '@ngrx/store';

import { User, UserLayersGroup } from '@core/api';

import { initActions } from '../actions/init.actions';
import { userApiActions } from '../actions/user.actions';

export const featureKey = 'user';

export type UserState = (User & { userLayersGroups?: UserLayersGroup[] }) | undefined;

export const initialState: UserState = undefined;

export const reducer = createReducer<UserState>(
  initialState,
  on(userApiActions.logoutSuccess, userApiActions.tokenExpired, userApiActions.tokenDeleted, () => initialState),

  on(initActions.appComplete, userApiActions.loginSuccess, (state, { user }) =>
    user ? { ...user, userLayersGroups: state?.userLayersGroups } : undefined
  ),

  on(userApiActions.fetchUserSuccess, (state, { user }) => (state ? { ...user, userLayersGroups: state.userLayersGroups } : user)),

  on(userApiActions.fetchUserLayersGroupsSuccess, (state, { userLayersGroups }) => (state ? { ...state, userLayersGroups } : state)),

  on(userApiActions.updateUserSuccess, (state, { user }) => (state ? { ...state, ...user } : state)),

  on(userApiActions.updateRegionConfig, (state, { regionConfig }) =>
    state
      ? {
          ...state,
          regionConfig: {
            ...regionConfig,
            defaultChanged: true,
          },
        }
      : state
  )
);
